import { render, staticRenderFns } from "./InputForm.vue?vue&type=template&id=73233207&scoped=true"
import script from "./InputForm.vue?vue&type=script&lang=js"
export * from "./InputForm.vue?vue&type=script&lang=js"
import style0 from "./InputForm.vue?vue&type=style&index=0&id=73233207&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73233207",
  null
  
)

export default component.exports